
import store from "@/store"
export const checkGuard = (guard)=>{
    return store.state.auth.user.permissions.includes(guard);
}